// import React, { useContext, useState } from 'react'
// import Container from '@mui/material/Container'
// import exisimg from "../assets/exsi.png"
// import imgfir from "../assets/fire.png"
// import Button from '@mui/material/Button'
// import { Link } from 'react-router-dom';
// import { AppContext } from '../context/ContenxtAPI'
// import "./dashboard.css"
// import Cookies from 'js-cookie'

// const BookRepair = () => {
//   const token = Cookies.get('token');
//   const [existingor, setExisting] = useState("")
//   const { BoilerRepaiers } = useContext(AppContext)

//   return (
//     <>
//       <Container maxWidth="xl">
//         <div className="existing_check">
//           <div className="existing_title_div">
//             <h1>Are You a New or Existing Customer?</h1>
//             <p>All Plans include limited repair with no limit on the value of each repair</p>
//           </div>
//           <div className="image_div_exis">
//             <div className='img_div_exis' onClick={() => setExisting("new")}>
//               <img src={exisimg} alt="icon" />
//               <p className='p_checking' style={{ color: existingor === 'new' ? "#604CD4" : 'rgb(0 0 0 / 45%)' }}>New Customer</p>
//             </div>
//             <div className='img_div_exis' onClick={() => setExisting("exi")}>
//               <img src={imgfir} alt="icon" />
//               <p className='p_checking' style={{ color: existingor === 'exi' ? "#604CD4" : 'rgb(0 0 0 / 45%)' }}>Existing Customer</p>
//             </div>
//           </div>
//           <Link to={`/${existingor === 'exi' ? 'CheckUser' : 'BoilerRepai'}`}>
//             <Button variant="contained" className='btnsteps'
//               onClick={existingor === 'new' ? () => setTimeout(()=>{BoilerRepaiers()},500) : null}>
//               Next
//             </Button>
//           </Link>
//         </div>
//       </Container>
//     </>
//   )
// }

// export default BookRepair
import React, { useContext, useState } from 'react'
import Container from '@mui/material/Container'
import exisimg from "../assets/exsi.png"
import imgfir from "../assets/fire.png"
import Button from '@mui/material/Button'
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../context/ContenxtAPI'
import "./dashboard.css"
import Cookies from 'js-cookie'

const BookRepair = () => {
  const token = Cookies.get('token');
  const [existingor, setExisting] = useState("")
  const { BoilerRepaiers } = useContext(AppContext)
  const navigate = useNavigate();

  const handleNextClick = () => {
    if (existingor === 'new') {
      setTimeout(() => {
        BoilerRepaiers();
      }, 500);
      navigate('/BoilerRepai');
    } else if (existingor === 'exi') {
      if (token) {
        navigate('/dashboard');
      } else {
        navigate('/Login');
      }
    }
  }

  return (
    <>
      <Container maxWidth="xl">
        <div className="existing_check">
          <div className="existing_title_div">
            <h1>Are You a New or Existing Customer?</h1>
            <p>All Plans include limited repair with no limit on the value of each repair</p>
          </div>
          <div className="image_div_exis">
            <div className='img_div_exis' onClick={() => setExisting("new")}>
              <img src={exisimg} alt="icon" />
              <p className='p_checking' style={{ color: existingor === 'new' ? "#604CD4" : 'rgb(0 0 0 / 45%)' }}>New Customer</p>
            </div>
            <div className='img_div_exis' onClick={() => setExisting("exi")}>
              <img src={imgfir} alt="icon" />
              <p className='p_checking' style={{ color: existingor === 'exi' ? "#604CD4" : 'rgb(0 0 0 / 45%)' }}>Existing Customer</p>
            </div>
          </div>
          <Button variant="contained" className='btnsteps' onClick={handleNextClick}>
            Next
          </Button>
        </div>
      </Container>
    </>
  )
}

export default BookRepair